export const mycoupon = {
    title: 'คูปองของฉัน',
    tab_available: 'ส่วนลดพร้อมใช้งาน',
    tab_expired: 'ส่วนลดใช้งานไปแล้ว',
    ExpireDate : 'หมดอายุ : ',
    UsePoint : 'ใช้คะแนน : ',
    GetPoint : 'GetPoint',
    Status: 'สถานะ :',
    Status_Expired: 'หมดอายุ',
    tab_subscription: 'แพ็กเกจ',
}
